import { createFileRoute } from "@tanstack/react-router";
import DemoGratuit from "@/pages/DemoGratuit";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/demo-gratuit/")({
  head: () => routeHead("/demo-gratuit/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DemoGratuit />
  );
}
